<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md8 lg6>
        <v-card class="elevation-20">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Tworzenie umowy najmu sprzętu muzycznego</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="dane"
                prepend-icon="open_in_browser"
                label="Dane do umowy"
                hint="W podglądzie zamówienia kliknij Drukuj. W nowym oknie Ctrl+A i Ctrl+C i wklej tutaj ten tekst."
                no-resize
                class="mb-2"
              ></v-textarea>
            </v-form>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-textarea
              v-model="zamawiajacy"
              prepend-icon="person"
              label="Zamawiający"
              disabled
              no-resize
              style="color: rgba(0,0,0); margin-left:40%;"
              class="mt-4"
            ></v-textarea>
            <div class="my-1">Zestaw gitarowy zawiera:</div>
            <v-data-table
              :headers="[{text: 'Nazwa towaru/usługi', sortable: false, value: 0}, {text: 'Ilość', sortable: false, value: 1}, {text: 'Cena', sortable: false, value: 2}, {text: 'Wartość', sortable: false, value: 3}]"
              :items="zestaw"
              hide-actions
              no-data-text="Nic"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item[0] }}</td>
                <td class="text-xs-right">{{ props.item[1] }}</td>
                <td class="text-xs-right">{{ props.item[2] }}</td>
                <td class="text-xs-right">{{ props.item[3] }}</td>
              </template>
            </v-data-table>
            <div class="mt-3">o łącznej wartości detalicznej brutto: <b>{{wartosczamowienia}} PLN</b> + przesyłka <b>{{przesylka}} PLN</b> = <b>{{wartosczamowienia+przesylka}} PLN</b></div>
            <div class="mt-1">całość za wypożyczenie: <b>{{wartosczamowienia+przesylka}} PLN </b></div>
            
            <div style="max-width: 240px;" class="mt-1">
              <v-select
                v-model="modelGitary"
                :items="['Alvera', 'Everplay']"
                label="Model gitary"
                outline
              />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="utworz"
              color="primary"
              :disabled="!modelGitary"
            >Utwórz</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'CreateUmowa',
  data () {
    return {
      dane: '',
      modelGitary: null,
      laczRaty: 0,
      ratyporowno: false,
      zaokraglaj: false
    }
  },
  computed: {
    zamawiajacy () {
      if (!this.nabywca && !this.adres) return ''
      return this.nabywca + '\n' + this.adres
    },
    nabywca () {
      if (!this.dane) return ''
      return this.dane.match(/Nabywca:([\s\S]+?)Adres dostawy:/)[1].replace(/\n+/g, '\n').trim()
    },
    adres () {
      if (!this.dane) return ''
      return this.dane.match(/Adres dostawy:([\s\S]+?)Sposób dostawy:/)[1].replace(/\n+/g, '\n').trim()
    },
    zestaw () {
      if (!this.dane) return []
      else {
        return this.dane.match(/(Nazwa towaru\/usługi[\s\S]+?)Wartość zamówienia/)[1].replace(/\n+/g, '\n').replace(/^\d\.$/gm, '----------').split('----------').map(x => x.split('\n')).slice(1).map(x => x.slice(1, -1))
      }
    },
    wartosczamowienia () {
      if (!this.zestaw.length) return '?'
      return this.zestaw.reduce((a, b) => {
        return parseFloat(a) + parseFloat(b[3].replace(',', '.'))
      }, 0)
    },
    przesylka () {
      if (!this.dane) return '?'
      return parseFloat(this.dane.match(/Koszt przesyłki:\n\n(.+?) PLN/)[1])
    },
    raty () {
      if (this.wartosczamowienia === '?') return []
      let caloscZaLeasing = this.wartosczamowienia + 60 + this.przesylka
      let raty
      if (this.ratyporowno) {
        if (10 - this.laczRaty === 0) this.laczRaty--
        raty = new Array(10 - this.laczRaty).fill(parseFloat(((caloscZaLeasing - 60) / (10 - this.laczRaty)).toFixed(this.zaokraglaj ? 0 : 2)))
        raty.unshift(60)
        let sumaRat = raty.reduce((a, b) => a + b, 0)
        if (sumaRat !== caloscZaLeasing) raty[raty.length - 1] = parseFloat((raty[raty.length - 1] + (caloscZaLeasing - sumaRat)).toFixed(2))
      } else {
        raty = new Array(Math.floor(caloscZaLeasing / 60)).fill(60)
        raty.push(parseFloat((caloscZaLeasing % 60).toFixed(2)))
        for (let i = 0; i < this.laczRaty + 1; i++) {
          if (i !== 0 || (raty[raty.length - 1] < 60)) {
            let ostatniaRata = raty[raty.length - 1]
            raty.splice(-1)
            raty[raty.length - 1] = parseFloat((ostatniaRata + raty[raty.length - 1]).toFixed(2))
          }
        }
      }
      return raty
    }
  },
  methods: {
    utworz () {
      this.$router.push({
        name: 'UmowaLeasing',
        params: {
          nabywca: this.nabywca.toString(),
          adres: this.adres.toString(),
          modelGitary: this.modelGitary.toString(),
          zestaw: JSON.stringify(this.zestaw),
          wartosczamowienia: this.wartosczamowienia.toString(),
          przesylka: this.przesylka.toString(),
          raty: JSON.stringify(this.raty),
          caloscZaLeasing: (this.wartosczamowienia + 60 + this.przesylka).toString()
        }
      })
    }
  }
}
</script>

<style scoped>
.v-input__slot {
  color: rgba(0,0,0) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateUmowa.vue